import { getVisitorLocaleFromWindow } from './getVisitorLocale';
export const getIsInMicrosoftAzureIPRange = () => {
  const visitorLocale = getVisitorLocaleFromWindow();
  if (!visitorLocale || !visitorLocale.ip) {
    return false;
  }
  return visitorLocale.ip.startsWith('40.94');
};